import { ref } from 'vue';
import { ethers } from 'ethers';

import { BULLDROIDS_JSON_URL, CONTRACT_ADDRESS } from '@/constants';
import BulldroidsTokenABI from '@/bulldroids-token-abi';

export const useBulldroid = (connectedAccount) => {
	const loading = ref(false);
	const error = ref(null);
	const bulldroids = ref([]);

	const getContract = async () => {
		try {
			const { ethereum } = window;
			const provider = new ethers.providers.Web3Provider(ethereum);
			const signer = provider.getSigner();
			const connectedContract = new ethers.Contract(
				CONTRACT_ADDRESS,
				BulldroidsTokenABI,
				signer,
			);
			return connectedContract;
		} catch {
			error.value = 'Contract not found';
			return null;
		}
	};

	/* eslint-disable */
	const fetchBulldroids = async () => {
		loading.value = true;

		try {
			const arr = [];
			const connectedContract = await getContract();
			const bulldroidsBalance = await connectedContract.balanceOf(connectedAccount);

			for (let i = 0; i < bulldroidsBalance; i += 1) {
				const tokenId = await connectedContract.tokenOfOwnerByIndex(connectedAccount, i);
				const tokenMetadata = await fetch(`${BULLDROIDS_JSON_URL}/${tokenId}.json`).then((response) => response.json());

				// Convert Bulldroid attributes to key value pairs Object
				tokenMetadata.attributes = tokenMetadata.attributes.reduce((obj, item) => {
					obj[item.trait_type.toLowerCase()] = item.value.replace(/_/g, ' ');
					return obj;
				}, {});

				// Display id in JSON
				// TODO: Update JSON to natively display the id
				tokenMetadata.id = tokenMetadata.name.split(' ').filter((v) => v.startsWith('#'))[0].replace(/#\b/g, '');

				arr.push(tokenMetadata);
			}

			bulldroids.value = arr;
		} catch (err) {
			error.value = err;
		} finally {
			setTimeout(() => {
				loading.value = false;
			}, 1000);
		}
	};
	/* eslint-enable */

	fetchBulldroids();

	return {
		loading,
		error,
		bulldroids,
	};
};

export default useBulldroid;
